/**
 * Adzuki
 * responsive_tables.js
 */

(function ResponsiveTable($, Adzuki)
{
	"use strict";

	var responsiveTable = function ResponsiveTable(el)
	{
		var $table,
			$radios,
			$rows;

		if (el instanceof jQuery) {
			$table = el;
		} else if (typeof el === 'string') {
			$table = $(el);
		}

		try
		{
			if (!$table.length) {
				throw new Error('selector not found');
			}

			// todo: comment out
			$table.addClass('adz-responsive-table');

			$rows       = $table.find('tbody tr, li.table-row');
			// $checkboxes = $rows.find('input[type=checkbox]');
			$radios     = $rows.find('input[type=radio]:not(.rt-selectable-input)');


			// check the box when clicking anywhere in a row
			$table.on('mouseup', 'tbody tr, .table-row', function rowClick(e)
			{
				var $target = $(e.target),
				    $parent = $target.parent();

				var $checkbox = $parent.find('input[type=checkbox]:first');
				var $radio    = $parent.find('input[type=radio]:first');
				var checked   = $checkbox.prop('checked');

				// this seems to be counting the number of checked checkboxes within the row. not sure if Brandon intended for this (maybe in some areas im unaware of?) or
				// made a mistake, but it broke a common use of this functionality, which would be counting the rows checked within a table. I'm assuming he made a mistake.
				// commenting out in case we need to revisit
				// var amount    = $parent.find('input[type=checkbox]:checked').length;

				// count of all the checked checkboxes within the table
				var amount = $table.find('input[type=checkbox]:checked').length;
				var max    = $table.data('max-selectable');

				// ...except for links and icons and stuff
				if ($target.is('a') || $parent.is('a') || $target.hasClass('rt-selectable-input')) {
					return;
				}

				// ...or row has unselectable class
				if ($parent.hasClass('unselectable')) {
					return;
				}

				// only if the "row" contains a checkbox
				// if ($checkbox.length <= 0 && $radio.length <= 0) {
				// 	console.log('no checkbox or radio? wat?');
				// 	return;
				// }

				if (amount >= max && !checked) {
					Adzuki.StatusMessage(null, 'You can only select up to ' + max + '.', 'Max reached');
					return;
				}

				// Grab current value of checkbox, set it as opposite and trigger event
				if ($checkbox) {
					// console.log("triggering checkboxes");
					$checkbox.prop('checked', !checked).trigger('change');
				}

				if ($radio) {
					// console.log("triggering radios");
					$radio.prop('checked', 'checked').trigger('change');
				}
			});

			// toggle row class
			$table.on('change', 'input[type="checkbox"]:not(.rt-selectable-input)', function toggleRowSelected() {
				$(this).parents('tr, li.table-row').toggleClass('selected', this.checked);
			});

			// // toggle row class
			$table.on('change', 'input[type="radio"]:not(.rt-selectable-input)', function toggleRowSelected() {
				$($radios).parents('tr, li.table-row').removeClass('selected');
				$(this).parents('tr, li.table-row').toggleClass('selected');
			});


			// Add row class to pre-checked items
			$rows.find('input[type=checkbox]:checked:not(.rt-selectable-input)').each(function addSelected() {
				$(this).parents('tr, li.table-row').addClass('selected');
			});


			// check all
			$table.find('.check-all + i').on('click', function toggleCheckAll() {
				var checked = $(this).prev('input[type=checkbox]:not(.rt-selectable-input)').prop('checked');
				$(this).prev('.check-all').prop('checked', !checked);

				$(this).parents('.table-selectable').find('input[type="checkbox"]:not(.rt-selectable-input)').each(function changeCheck(index, el) {
					if ($(el).parents('tr, li.table-row').hasClass('unselectable')) {
						// do not select row with unselectable class
						return;
					}

					$(el).prop('checked', !checked);
					$(el).parents('tr, li.table-row').toggleClass('selected', !checked);
				});

				$(this).parents('.table-selectable').find('input[type="radio"]:not(.rt-selectable-input)').each(function changeRadio(index, el) {
					if ($(el).parents('tr, li.table-row').hasClass('unselectable')) {
						// do not select row with unselectable class
						return;
					}

					$(el).prop('checked', !checked);
					$(el).parents('tr, li.table-row').toggleClass('selected', !checked);
				});
			});


			// The purpose of this is to allow entire "rows" with a single
			// checkbox to be clickable in order to toggle the checkbox's checked property
			if ($table.find('.table-row.toggle-checkbox p').length > 0) {
				$table.find('.table-row.toggle-checkbox p').click(function rowClicked() {
					var $self     = $(this),
					    $row      = $self.parents('.table-row.toggle-checkbox'),
					    $checkbox = $row.find('input:checkbox:first'),
					    checked;

					// only if the "row" contains a checkbox
					if ($checkbox.length <= 0 ) {
						return;
					}

					// only if they aren't clicking on the checkbox itself
					if ($self.find('input:checkbox').length > 0) {
						return;
					}

					// if they are clicking a link, we don't want to toggle the checkbox
					if ($self.find('a').length > 0) {
						return;
					}

					checked = $checkbox.prop('checked');

					if (checked === false) {
						$checkbox.prop('checked', true);
					} else {
						$checkbox.prop('checked', false);
					}
				});
			}
		}
		catch (err)
		{
			console.error('[Adzuki.ResponsiveTable]', err);
		}
	};



	// auto-init on page loads
	$(document).ready(function documentReady() {
		var $tables = $('.table-selectable');
		if ($tables.length) {
			responsiveTable($tables);
		}
	});

	Adzuki.ResponsiveTable = responsiveTable;
}(jQuery, window.Adzuki || {}));
